import script from "./tapTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./tapTop.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__